<p-fluid>
  <div
    [class.xofmanyrequired]="
      parentForm()?.errors?.xofmanyrequired && isOneOfManyRequired()
    "
    class="w-100"
  >
    <p-select
      #communitySelection="ngModel"
      name="communitySelection"
      [options]="getCommunityOptions()"
      dataKey="orgId"
      [required]="required()"
      [(ngModel)]="selectedCommunity"
      (onChange)="onChange()"
      [placeholder]="placeholder()"
      [disabled]="disabled"
      [filter]="true"
      filterBy="label"
      appendTo="body"
    />
  </div>
  <error-message [errorControl]="communitySelection">
    @if (communitySelection?.errors?.required) {
      <span>Please select at least one community to continue.</span>
    }
  </error-message>
</p-fluid>
